import { useIntl } from 'react-intl'
import styled from 'styled-components'

import { Box, Button, THEME, ThemeProvider } from '@themenu/design-system'

import { environmentVariables } from '../../utils/environmentVariables'

const StyledButton = styled(({ ...props }) => <Button {...props} />)`
  background: rgb(0 0 0 / 45%);
  font-weight: 400;
`

export const HelpButton = (): JSX.Element => {
  const intl = useIntl()

  return (
    <Box display="flex" justifyContent="end">
      <ThemeProvider theme={THEME.LIGHT}>
        <StyledButton
          endIcon="phone"
          variant="primary"
          size={32}
          mb={16}
          mr={16}
          component="a"
          href={environmentVariables('HELP_URL')}
        >
          {intl.formatMessage({ id: 'help.title' })}
        </StyledButton>
      </ThemeProvider>
    </Box>
  )
}
